/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Why_LockInputs */

const en_landing_why_lock = /** @type {(inputs: Landing_Why_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In this workspace`)
};

const zh_landing_why_lock = /** @type {(inputs: Landing_Why_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本工作台`)
};

/**
* | output |
* | --- |
* | "In this workspace" |
*
* @param {Landing_Why_LockInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_why_lock = /** @type {((inputs?: Landing_Why_LockInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Why_LockInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_why_lock(inputs)
	return zh_landing_why_lock(inputs)
});
export { landing_why_lock as "landing.why.lock" }